module.exports = __webpack_public_path__ + "img/audio_wave.422bbb02.gif";